<script setup>
import {useBaseStore} from "~/stores/base";
import Drawer from "~/components/Drawer.vue";
import {useProductStore} from "~/stores/product";
import _ from "lodash";
import {Loading} from "@element-plus/icons-vue";
import {voteSubmit} from "~/api/api.vote";
import {toLogin} from "~/utils/common";

const BNTOMessage = useNuxtApp().$BNTOMessage
const router = useRouter()
const route = useRoute()

/** emits **/
const emits = defineEmits([])

/** props **/
const props = defineProps({})

/** data **/
const comment = ref("")
const selectIndex = ref(-1)
const animationIndex = ref(-1)
const isLoading = ref(false)

/** computed **/
const isMobile = computed(() => useBaseStore().getterIsMobile)
const isLogin = computed(() => useBaseStore().getterIsLogin)
const userInfo = computed(() => useBaseStore().getterUserInfo)
const open = computed(() => useProductStore().getterIsShowDrawerProductVotePlayer)
const voteRole = computed(() => useProductStore().getterVoteRole)
const voteData = computed(() => useProductStore().getterVoteData)
const btnConfirmDisabled = computed(() => selectIndex.value === -1)
const query = computed(() => route.query)

/** watch **/

/** methods **/
const handleClose = () => {
  const query = _.cloneDeep(router.currentRoute.value.query)
  delete query.voteId
  // 获取当前路径，但去掉 hash 部分
  router.replace({
    path: router.currentRoute.value.path,
    query: query, // 更新query
    hash: router.currentRoute.value.hash
  });
}
const select = (index) => {
  if (!isLogin.value) return toLogin({query: {redirect_uri: route.fullPath}})
  selectIndex.value = -1
  animationIndex.value = index
}
const handleAnimationEnd = (index) => {
  animationIndex.value = -1
  selectIndex.value = index
}
const handleSend = async () => {
  if (btnConfirmDisabled.value) return
  if (isLoading.value) return
  isLoading.value = true
  await voteSubmit({shareId: query.value.voteId, optionLabel: selectIndex.value + 1, descriptionText: comment.value})
  isLoading.value = false
  BNTOMessage.sparkle({
    title: "Voting successful",
    message: "Your selection has been successfully submitted to your friend!",
  })
  handleClose()
}

/** lifecycle **/

</script>

<template>
  <div class="drawer-product-vote-player-mobile" v-if="isMobile">
    <Drawer
      :open="open"
      @close="handleClose"
      :btn-close-visible="false"
      :position="'bottom'"
      :border-radius="'8px 8px 0 0'"
      :z-index="4"
      :global-header-visible="false"
    >
      <div class="drawer" v-if="open">
        <div class="drawer-header">
          <div class="drawer-header-left"></div>
          <div class="title">
            {{ voteData.topTitle }}
          </div>
          <div class="close" @click="handleClose"><img src="@/assets/img/icon-close-black.svg" alt="icon"></div>
        </div>

        <div class="drawer-body">
          <div class="info" v-if="voteData.nickname && voteData.avatarName">
            <div class="avatar" :style="{backgroundColor: voteData.avatarBg}">{{ voteData.avatarName }}</div>
            <div class="nickname">{{ voteData.nickname }}</div>
          </div>
          <div class="content">
            <div class="desc">{{ voteData.descriptionText }}</div>
            <div class="selects">
              <div class="selection" @click="select(0)">
                <img v-show="selectIndex !== 0 && animationIndex !== 0" src="@/assets/img/icon-like.png" alt="like">
                <animation-like v-show="animationIndex === 0" @animationend="handleAnimationEnd"/>
                <img v-show="selectIndex === 0" src="@/assets/img/icon-like-selected.png" alt="like">
              </div>
              <div class="selection" @click="select(1)">
                <img v-show="selectIndex !== 1 && animationIndex !== 1" src="@/assets/img/icon-half-like.png" alt="like">
                <animation-half-like v-show="animationIndex === 1" @animationend="handleAnimationEnd"/>
                <img v-show="selectIndex === 1" src="@/assets/img/icon-half-like-selected.png" alt="like">
              </div>
              <div class="selection" @click="select(2)">
                <img v-show="selectIndex !== 2 && animationIndex !== 2" src="@/assets/img/icon-unlike.png" alt="like">
                <animation-unlike v-show="animationIndex === 2" @animationend="handleAnimationEnd"/>
                <img v-show="selectIndex === 2" src="@/assets/img/icon-unlike-selected.png" alt="like">
              </div>
            </div>
            <div class="input">
              <module-input
                :title="'Any other thoughts and feelings?'"
                :placeholder="'Add your comment'"
                v-model="comment"
                :max-length="90"
              />
            </div>
          </div>
        </div>

        <div class="drawer-footer">
          <div class="btn-primary" :class="{'btn-disabled': btnConfirmDisabled || isLoading}" @click="handleSend">
            <el-icon v-if="isLoading" class="is-loading" color="white" size="16" style="margin-right: 8px">
              <Loading/>
            </el-icon>
            <span>send</span>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
  <div class="drawer-product-vote-player-desktop" v-else>
    <Drawer :open="open" :position="'right'" @close="handleClose">
      <div class="drawer" v-if="open">
        <div class="drawer-header">
          <div class="drawer-header-left"></div>
          <div class="title">
            {{ voteData.topTitle }}
          </div>
          <div class="close" @click="handleClose"><img src="@/assets/img/icon-close-black.svg" alt="icon"></div>
        </div>

        <div class="drawer-body">
          <div class="info" v-if="voteData.nickname && voteData.avatarName">
            <div class="avatar" :style="{backgroundColor: voteData.avatarBg}">{{ voteData.avatarName }}</div>
            <div class="nickname">{{ voteData.nickname }}</div>
          </div>
          <div class="content">
            <div class="desc">{{ voteData.descriptionText }}</div>
            <div class="selects">
              <div class="selection" @click="select(0)">
                <img v-show="selectIndex !== 0 && animationIndex !== 0" src="@/assets/img/icon-like.png" alt="like">
                <animation-like v-show="animationIndex === 0" @animationend="handleAnimationEnd"/>
                <img v-show="selectIndex === 0" src="@/assets/img/icon-like-selected.png" alt="like">
              </div>
              <div class="selection" @click="select(1)">
                <img v-show="selectIndex !== 1 && animationIndex !== 1" src="@/assets/img/icon-half-like.png" alt="like">
                <animation-half-like v-show="animationIndex === 1" @animationend="handleAnimationEnd"/>
                <img v-show="selectIndex === 1" src="@/assets/img/icon-half-like-selected.png" alt="like">
              </div>
              <div class="selection" @click="select(2)">
                <img v-show="selectIndex !== 2 && animationIndex !== 2" src="@/assets/img/icon-unlike.png" alt="like">
                <animation-unlike v-show="animationIndex === 2" @animationend="handleAnimationEnd"/>
                <img v-show="selectIndex === 2" src="@/assets/img/icon-unlike-selected.png" alt="like">
              </div>
            </div>
            <div class="input">
              <module-input
                :title="'Any other thoughts and feelings?'"
                :placeholder="'Add your comment'"
                v-model="comment"
                :max-length="90"
              />
            </div>
          </div>
        </div>

        <div class="drawer-footer">
          <div class="btn-primary" :class="{'btn-disabled': btnConfirmDisabled || isLoading}" @click="handleSend">
            <el-icon v-if="isLoading" class="is-loading" color="white" size="16" style="margin-right: 8px">
              <Loading/>
            </el-icon>
            <span>send</span>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
</template>

<style scoped lang="scss">
@import "src/assets/config";

.drawer-product-vote-player-mobile {
  .drawer {
    width: 100%;
    height: calc(100vh - $mobile-header-height - $mobile-safari-address-bar-height);
    padding-top: 14px;
    display: flex;
    flex-direction: column;

    .drawer-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 16px;

      .drawer-header-left {
        width: 40px;
        height: 40px;

        .back {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .title {
        font-family: "TWK Lausanne";
        font-size: 14px;
        font-style: normal;
        font-weight: 650;
        line-height: 18px;
        letter-spacing: -0.056px;
        text-transform: uppercase;
      }

      .close {
        cursor: pointer;
        flex-shrink: 0;

        border: 1px solid $color-BNTO-beige-dark;

        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
      }
    }

    .drawer-body {
      flex: 1;
      padding: 0 16px;
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .info {
        display: flex;
        align-items: center;
        gap: 8px;

        .avatar {
          display: flex;
          width: 52px;
          height: 52px;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 50%;

          color: $color-BNTO-beige-dark;
          text-align: center;
          font-family: "TWK Lausanne";
          font-size: 22px;
          font-style: normal;
          font-weight: 650;
          line-height: 20px; /* 90.909% */
        }

        .nickname {
          font-family: "TWK Lausanne";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 19px; /* 135.714% */
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .desc {
          font-family: "TWK Lausanne";
          font-size: 14px;
          font-style: normal;
          font-weight: 300;
          line-height: 18px; /* 128.571% */
          letter-spacing: -0.056px;
        }

        .selects {
          display: flex;
          align-items: center;
          gap: 16px;

          .selection {
            display: flex;
            cursor: pointer;

            img {
              width: 60px;
              height: 50px;
            }
          }
        }

        .input {

        }
      }
    }

    .drawer-footer {
      padding: 0 16px;
      width: 100%;
      position: absolute;
      bottom: 30px;
    }
  }
}

.drawer-product-vote-player-desktop {
  .drawer {
    width: 432px;
    height: calc(100vh - $desktop-header-height);
    padding-top: 14px;
    display: flex;
    flex-direction: column;

    .drawer-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 6px 16px;

      .drawer-header-left {
        width: 40px;
        height: 40px;

        .back {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
      }

      .title {
        font-family: "Alternate Gothic No3 D";
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 32px; /* 88.889% */
        letter-spacing: -0.36px;
        text-transform: uppercase;
        padding-top: 12px;
      }

      .close {
        cursor: pointer;
        flex-shrink: 0;

        border: 1px solid $color-BNTO-beige-dark;

        width: 40px;
        height: 40px;
        display: flex;
        justify-content: center;
        align-items: center;

        img {
          width: 20px;
          height: 20px;
          flex-shrink: 0;
        }
      }
    }

    .drawer-body {
      flex: 1;
      padding: 0 16px;
      margin-top: 16px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .info {
        display: flex;
        align-items: center;
        gap: 8px;

        .avatar {
          display: flex;
          width: 52px;
          height: 52px;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          border-radius: 50%;

          color: $color-BNTO-beige-dark;
          text-align: center;
          font-family: "TWK Lausanne";
          font-size: 22px;
          font-style: normal;
          font-weight: 650;
          line-height: 20px; /* 90.909% */
        }

        .nickname {
          font-family: "TWK Lausanne";
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 19px; /* 135.714% */
        }
      }

      .content {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .desc {
          font-family: "TWK Lausanne";
          font-size: 14px;
          font-style: normal;
          font-weight: 300;
          line-height: 18px; /* 128.571% */
          letter-spacing: -0.056px;
        }

        .selects {
          display: flex;
          align-items: center;
          gap: 16px;

          .selection {
            display: flex;
            cursor: pointer;

            img {
              width: 60px;
              height: 50px;
            }
          }
        }

        .input {

        }
      }
    }

    .drawer-footer {
      padding: 0 16px;
      width: 100%;
      position: absolute;
      bottom: 30px;
    }
  }
}
</style>
